<template lang="pug">
  .b2b-table-taxes
    //- Filtros Tabla Servicios
    b2b-filters-taxes(:filter-options='options')
    ods-table(
      :data='taxes.tableData',
      :default-sort="{prop: 'enable', order: 'descending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='mini',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='taxType',
        :label='$t("taxes.taxes_table.type")',
        :show-overflow-tooltip='true',
        :formatter='formatterType',
        v-if='isShowTypeTaxes',
        sortable='')
      ods-table-column(
        prop='taxRate',
        :label='$t("taxes.taxes_table.rate")',
        align='right',
        :show-overflow-tooltip='true',
        :formatter='formatterQuantity',
        v-if='isShowRateTaxes',
        sortable='')
      ods-table-column(
        prop='countryCodeAlfa3',
        :label='$t("taxes.taxes_table.country")',
        :show-overflow-tooltip='true',
        :formatter='formatterCountry',
        v-if='isShowCountryTaxes',
        sortable='')
      ods-table-column(
        prop='dateFrom',
        :label='$t("taxes.taxes_table.validity_date_from")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateFromTaxes',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='dateTo',
        :label='$t("taxes.taxes_table.validity_date_to")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateToTaxes',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='enable',
        :label='$t("taxes.taxes_table.enable")',
        v-if='isShowEnabledTaxes',
        sortable='')
        template(slot-scope='scope')
          ods-switch(v-model='scope.row.enable',
            :disabled='!canAdminTaxes',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='goUpdateTax(scope.row)')
      ods-table-column(
        prop='project',
        :label='$t("mailTemplates.mailTemplates_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowProjectTaxes && isSuperAdmin',
        min-width='100',
        sortable='')
      ods-table-column(
        align='center',
        label,
        :render-header='renderHeaderActions',
        width='85')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px; text-align: center;'
              type='neutral',
              icon-position='left'
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('buttons.btnDelete') }}
            ods-button(
               v-if='canAdminTaxes'
              style=' padding-left: 0px; padding-right: 0px; text-align: center;'
              type='neutral',
              @click='handleRemoveTax(scope.row)')
              ods-icon(name='close', size='16')

    ods-row.b2b-table-taxes__pagination()
      ods-col.b2b-table-taxes__pagination--left(:span='4')

      //- Paginación Tabla
      ods-col.b2b-table-taxes__pagination--right(:span='24')
        ods-pagination(
        ref='pagination',
        popper-class='b2b-pagination__dropdown',
        @size-change='handleSizeChange',
        @current-change='handleCurrentChangePagination',
        :current-page.sync='currentPage',
        :page-sizes='[20, 50, 100]',
        :page-size='20',
        layout='total, sizes, prev, pager, next, slot',
        :total='taxes.totalTaxes')

    //- Servicios Seleccionados
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import B2bFiltersTaxes from '@/views/administracion/taxes/B2bFiltersTaxes'
import B2bTableMenuTaxes from '@/views/administracion/taxes/B2bTableMenuTaxes'
import filters from './filtros-taxes'
import moment from 'moment'

export default {
  name: 'b2b-table-taxes',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      isSuperAdmin: false,
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'taxes',
      'queryTaxes',
      'isShowTypeTaxes',
      'isShowRateTaxes',
      'isShowDateFromTaxes',
      'isShowDateToTaxes',
      'isShowCountryTaxes',
      'isShowEnabledTaxes',
      'canAdminTaxes',
      'primaryColor',
      'isShowProjectTaxes'
    ])
  },

  components: {
    B2bFiltersTaxes,
    B2bTableSelectRows,
    B2bTableMenuTaxes
  },

  methods: {
    ...mapActions([
      'queryTaxesState',
      'getTaxes',
      'deleteTax',
      'activeTax'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }
        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'DESC'
        }
        if (!prop) {
          prop = 'enable'
        } else {
          switch (prop) {
            case 'project':
              prop = 'project.name'
              break
            case 'countryCodeAlfa3':
              prop = 'country.codeAlfa3'
              break
            case 'taxType':
              prop = 'taxType.tax'
              break
            case 'taxRate':
              prop = 'rate'
              break
          }
        }
        stringSort = prop + ',' + order
        this.queryTaxes.sort = stringSort
        await this.queryTaxesState(this.queryTaxes)
        dataQuery.query = this.queryTaxes
        const response = await this.getTaxes(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
        console.log('order stringSort ', stringSort)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },
    formatterCountry (row, column) {
      return row.countryCodeAlfa3 != null ? this.$t('countries.country_' + row.countryCodeAlfa3) : null
    },
    formatterType (row, column) {
      return row.taxType != null ? this.$t('adminTaxes.tax.' + row.taxType) : null
    },
    formatterQuantity (row) {
      if (row.taxRate) {
        return this.$n(row.taxRate, 'decimal')
      }
      return this.$n(0, 'decimal')
    },
    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    /* Eliminar el impuesto si no está asignado a ninguna factura */
    async handleRemoveTax (tax) {
      this.$confirm(this.$t('taxes.confirm.delete_tax'), {
        confirmButtonText: this.$t('buttons.btnDelete'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('taxes.load.delete_tax')
        })
        try {
          await this.deleteTax({ taxId: tax.id })
          this.$notify({
            title: this.$t('taxes.notify.delete_tax'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          const dataQuery = { query: {} }
          this.options = filters.filters
          dataQuery.query = this.queryTaxes
          await this.getTaxes(dataQuery)
        } catch (error) {
          console.log('handleRemoveTax CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          if (error.data.message) { errorSms = error.data.message } else { errorSms = error.message }
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    /* Ir al detalle */
    handleGoDetail (tax) {
      let taxname = this.currentRow.taxType
      if (taxname) {
        taxname = this.$t('adminTaxes.tax.' + taxname)
      }
      if (this.currentRow.taxRate || this.currentRow.taxRate === 0) {
        taxname = taxname + ' - ' + this.$n(this.currentRow.taxRate, 'decimal') + '%'
      } else {
        taxname = taxname + ' - ' + this.$n(0, 'decimal') + '%'
      }
      router.push({
        name: 'tax-detail',
        params: {
          taxId: this.currentRow.id,
          taxname: taxname
        }
      })
    },

    /** Guarda el cambio de estado de un impuesto (Habilitado/Deshabilitado) */
    async goUpdateTax (row) {
      const request = {
        taxId: row.id,
        enable: row.enable
      }
      await this.activeTax(request)

      /* let dataQuery = {query: {}}
      this.options = filters.filters
      dataQuery.query = this.queryTaxes
      await this.getTaxes(dataQuery) */

      const resultMsg = this.$t('taxes.notify.save_changes')

      this.$notify({
        title: resultMsg,
        type: 'success',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuTaxes />
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        this.queryTaxes.size = val
        await this.queryTaxesState(this.queryTaxes)
        dataQuery.query = this.queryTaxes
        const response = await this.getTaxes(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }
        this.queryTaxes.page = val - 1
        await this.queryTaxesState(this.queryTaxes)
        dataQuery.query = this.queryTaxes

        const response = await this.getTaxes(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.isSuperAdmin = this.activeUser.data.isSuperAdmin
      this.options = filters.filters
    } catch (error) {
      console.log('getUsers CATCH: ', error)
      this.showNotificationError(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-taxes {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
